<rid-demo-page [title]="'Fonologisch bewustzijn'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Wisselklanken" variant="PRIMARY" routerLink="klank-switch" [queryParams]="{ shuffle: 1 }" />
  <rid-button class="w-full" content="Klankvoeten (splitsen)" variant="PRIMARY" routerLink="klankvoeten" />
  <rid-button class="w-full" content="Klankvoeten (herkennen)" variant="PRIMARY" routerLink="klankvoeten-recognize" />
  <rid-button class="w-full" content="Woordpad" variant="PRIMARY" routerLink="word-path" />
  <rid-button class="w-full" content="Lettermix" variant="PRIMARY" routerLink="lettermix" />
</rid-demo-page>
